import { Injectable } from '@angular/core';

import { FormLikeFieldValidationHandler } from '../../canvas-elements/io-data/default-handlers/formlike-field-validation-handler.service';
import { ConnectValidationConfig } from '../../canvas-elements/io-data/io-data.models';
import { FormlikeFieldValidityObservable } from '../../services/forms/runtime/public-api';

@Injectable({ providedIn: 'root' })
export class FormListValidationHandler extends FormLikeFieldValidationHandler {
  protected override observeFieldValidity({
    element,
  }: ConnectValidationConfig): FormlikeFieldValidityObservable {
    return this.formValidity.observeFormListValidity(element);
  }
}
